
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { isEmpty } from 'lodash';

import { isCondoWeeklySpeccialMarketingFromPath, Responsive, RootState } from '@share/utils';
import { DISPLAY_HEADER_MESSAGE_LABEL } from '@constants';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import './style.scss';

export function ApplicationHeaderMessage() {
  const loginStore = useSelector((state: RootState) => state.loginStore);
  const menuStore = useSelector((state: RootState) => state.navigationMenuStore);

  const { loading, account, user } = loginStore;
  const { items } = menuStore;

  const [display, setDisplay] = useState(true);

  const history = useHistory();

  // Check if Modern template should be used (both SiteId AND OrgId must match)
  const siteId = items?.siteId;
  const organizationId = items?.organizationId;
  const modernHomeTemplateOrgidList = account?.modernHomeTemplateOrgidList;
  const modernHomeTemplateSiteidList = account?.modernHomeTemplateSiteidList;

  const isInModernOrgId = modernHomeTemplateOrgidList?.includes(organizationId?.toString() as string);
  const isInModernSiteId = modernHomeTemplateSiteidList?.includes(siteId?.toString() as string);

  const useModernTemplate = account?.isRSITemplate && (
    (isInModernOrgId && isInModernSiteId) || 
    (account?.isModernTemplate)
  );

  useEffect(() => {
    const displayHeaderMessageStorage = localStorage.getItem(DISPLAY_HEADER_MESSAGE_LABEL);
    if (!isEmpty(displayHeaderMessageStorage)) {
      setDisplay(displayHeaderMessageStorage === 'true');
    }
  }, []);

  const isCondoWeeklySpecialMarketing = useMemo(() => isCondoWeeklySpeccialMarketingFromPath(history), [history]);

  if (
    !display ||
    loading ||
    !account ||
    !user ||
    !account?.displayHeaderMessage ||
    isEmpty(account?.headerMessage) ||
    useModernTemplate ||
    isCondoWeeklySpecialMarketing
  ) {
    return null;
  }

  const handleCloseMessage = () => {
    localStorage.setItem(DISPLAY_HEADER_MESSAGE_LABEL, 'false');
    setDisplay(false);
  };

  const style: any = {};
  if (!isEmpty(account?.headerMessageColor)) {
    style.backgroundColor = account?.headerMessageColor;
  }

  return (
    <Responsive>
      <div className="header-message__container" style={style}>
        <label>{account?.headerMessage}</label>
        <div onClick={handleCloseMessage}>
          <FontAwesomeIcon icon={faTimes} />
        </div>
      </div>
    </Responsive>
  );
}
